/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Use_2_ValueInputs */

const en_svc_rag_use_2_value = /** @type {(inputs: Svc_Rag_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New staff find the procedure, price or policy without asking the person who has always known.`)
};

const lv_svc_rag_use_2_value = /** @type {(inputs: Svc_Rag_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jauni darbinieki atrod procedūru, cenu vai noteikumu, nejautājot kolēģim, kurš to vienmēr ir zinājis.`)
};

/**
* | output |
* | --- |
* | "New staff find the procedure, price or policy without asking the person who has always known." |
*
* @param {Svc_Rag_Use_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_use_2_value = /** @type {((inputs?: Svc_Rag_Use_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Use_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_use_2_value(inputs)
	return en_svc_rag_use_2_value(inputs)
});